import { render, staticRenderFns } from "./ProductDepartmentSidebar.vue?vue&type=template&id=dbeea022&"
import script from "./ProductDepartmentSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductDepartmentSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbeea022')) {
      api.createRecord('dbeea022', component.options)
    } else {
      api.reload('dbeea022', component.options)
    }
    module.hot.accept("./ProductDepartmentSidebar.vue?vue&type=template&id=dbeea022&", function () {
      api.rerender('dbeea022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-department/ProductDepartmentSidebar.vue"
export default component.exports